import { ShieldQuestion } from "lucide-react";

/**
 * What a SPOC-designated member has typed and the SPOC has not yet verified.
 * It never replaces the verified figure — it sits beside it.
 */
export const UnverifiedBadge = ({ mark, testId, compact = false }) => {
  if (!mark?.count) return null;
  const who = mark.waiting_on || "the SPOC";
  const title =
    `${mark.count} change(s) recorded by ${mark.by}, awaiting verification by ${who}:\n` +
    (mark.summaries || []).map((s) => `· ${s}`).join("\n") +
    "\nThe review packs keep reading the verified figures until then.";

  return (
    <span
      data-testid={testId}
      title={title}
      className={`inline-flex items-center gap-1 border font-display font-bold uppercase tracking-wider ${
        compact ? "px-1.5 py-0.5 text-[9px]" : "px-2 py-1 text-[10px]"
      }`}
      style={{
        borderColor: "hsl(36 92% 44%)",
        color: "hsl(36 92% 44%)",
        backgroundColor: "hsl(36 92% 44% / 0.1)",
      }}
    >
      <ShieldQuestion className={compact ? "h-3 w-3" : "h-3.5 w-3.5"} />
      {compact ? `${mark.count} awaiting` : `Awaiting verification · ${mark.count}`}
    </span>
  );
};
